var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyWhiteInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.66803 17.1541H13.116C14.3231 17.1541 15.3039 16.1735 15.3039 14.9662V7.26215C15.3039 6.05503 14.3233 5.07422 13.116 5.07422H7.66803C6.46091 5.07422 5.4801 6.05485 5.4801 7.26215V14.9662C5.4801 16.1733 6.46073 17.1541 7.66803 17.1541ZM6.8801 7.26201C6.8801 6.82533 7.2312 6.47408 7.66803 6.47408H13.116C13.5527 6.47408 13.9039 6.82518 13.9039 7.26201V14.966C13.9039 15.4027 13.5528 15.754 13.116 15.754H7.66803C7.23135 15.754 6.8801 15.4028 6.8801 14.966V7.26201Z",
    fill: "#11142D",
    stroke: "#11142D",
    strokeWidth: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.944 14.0213H17.1854L17.1535 13.9893C17.4406 13.8991 17.644 13.6286 17.644 13.3213V6.25327C17.644 4.28998 16.0511 2.69727 14.088 2.69727H9.28801C8.89675 2.69727 8.58801 3.00602 8.58801 3.39727C8.58801 3.78853 8.89675 4.09727 9.28801 4.09727H14.088C15.2809 4.09727 16.244 5.0606 16.244 6.25331V13.3213C16.244 13.7126 16.5528 14.0213 16.944 14.0213Z",
    fill: "#11142D",
    stroke: "#11142D",
    strokeWidth: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyWhiteInactive);
export default __webpack_public_path__ + "static/media/copy_white_inactive.e4497382477393c48f9fc30c227d3996.svg";
export { ForwardRef as ReactComponent };